import i18next from "i18next";
import { ApiResponse } from "../apiResponse";
import {
  clearAuthCredentials,
  getAuthCredentials,
  sanitizeAuthCredentials,
} from "../helpers/authHelpers";

// @description: This method is to be used as a generic error handler in interceptors
// @return: rejected Promise
export async function genericErrorInterceptor(error: any): Promise<any> {
  return Promise.reject(error);
}

// ------- Request interceptors

// @description: This method is to be used to inject auth headers into request
// @return: Object containing axios config
export function authCredentialsRequestInterceptor(config: any): Promise<any> {
  const authCredentials = getAuthCredentials();
  const sanitizedAuthCredentials: { [key: string]: any } =
    sanitizeAuthCredentials(authCredentials);
  if (Object.keys(sanitizedAuthCredentials).length > 0) {
    config.headers = { ...config.headers, ...sanitizedAuthCredentials };
  }
  return config;
}

// @description: This method is to be used to inject language headers into request
// @return: Object containing axios config
export async function languageRequestInterceptor(config: any): Promise<any> {
  config.headers["Accept-Language"] = i18next.language;
  return config;
}

// ------- Response interceptors

// @description: This method is to be used to parse successful request response data into an ApiResponse object
// @return: ApiResponse instance
export async function apiResponseInterceptor(response: any): Promise<any> {
  return new ApiResponse(response);
}

// @description: This method is to be used to parse unsuccessful request response data into an ApiResponse object
// @return: ApiResponse instance
export async function apiErrorResponseInterceptor(error: any): Promise<any> {
  if (error.response && error.response.status === 401) {
    clearAuthCredentials();
  }
  if (
    error.response &&
    error.response.status === 402 &&
    window.location.pathname !== "/student/dashboard/payment"
  ) {
    window.location.href = "/student/dashboard/payment";
  }
  return Promise.resolve(new ApiResponse(error.response));
}
